export default "__VITE_PUBLIC_ASSET__abec0aeb__"